import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import BaseDialogLayout from '../BaseDialogLayout';

import './GeneralDialogLayout.custom.scss';
import './GeneralDialogLayout.theme.scss';

export default function GeneralDialogLayout(props) {
  const { content, children, className, layoutType, headerClassName, footerClassName, contentClassName, id, ...otherProps } = props;
  const showbackdrop = id === 'heatmap-navigator-dialog' ? '' : 'react-dialogs-with-backdrop';
  const backdropClassName = classnames('react-dialogs-backdrop', showbackdrop);
  return (
    <div className={backdropClassName}>
      <BaseDialogLayout
        {...otherProps}
        className={classnames(className, 'general-dialog-layout', `general-dialog-layout-${layoutType}`)}
        headerClassName={classnames(headerClassName, 'general-dialog-layout-header')}
        footerClassName={classnames(footerClassName, 'general-dialog-layout-footer')}
        contentClassName={classnames(contentClassName, 'general-dialog-layout-content')}>
        {children || content}
      </BaseDialogLayout>
    </div>
  );
}

GeneralDialogLayout.defaultProps = {
  layoutType: 'branded',
};

GeneralDialogLayout.propTypes = {
  layoutType: PropTypes.oneOf(['nothing', 'branded', 'info', 'question', 'error', 'success']),
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  headerClassName: PropTypes.string,
  footerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
};
